import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import type { NavItem } from './DashboardLayout';
import './DashboardSidebar.css';

interface DashboardSidebarProps {
  navItems: NavItem[];
  collapsed: boolean;
  onToggle: () => void;
}

const DashboardSidebar: React.FC<DashboardSidebarProps> = ({
  navItems,
  collapsed,
  onToggle,
}) => {
  const location = useLocation();

  return (
    <aside className={`dl-sidebar ${collapsed ? 'dl-sidebar--collapsed' : ''}`}>
      <button
        className="dl-sidebar-toggle"
        onClick={onToggle}
        aria-label={collapsed ? 'Espandi menu' : 'Comprimi menu'}
      >
        <i
          className={`bi ${collapsed ? 'bi-chevron-right' : 'bi-chevron-left'}`}
        />
      </button>

      <nav className="dl-sidebar-nav">
        {navItems.map((item) => {
          const isActive = item.end
            ? location.pathname === item.path
            : location.pathname.startsWith(item.path);

          return (
            <NavLink
              key={item.path}
              to={item.path}
              end={item.end}
              className={`dl-sidebar-item ${isActive ? 'dl-sidebar-item--active' : ''}`}
              title={collapsed ? item.label : undefined}
            >
              <span className="dl-sidebar-icon-wrap">
                <i className={`bi ${item.icon}`} />
                {item.badgeCount != null && item.badgeCount > 0 && (
                  <span className="dl-sidebar-badge">
                    {item.badgeCount > 9 ? '9+' : item.badgeCount}
                  </span>
                )}
              </span>
              {!collapsed && (
                <span className="dl-sidebar-label">{item.label}</span>
              )}
            </NavLink>
          );
        })}
      </nav>

      <div className="dl-sidebar-footer">
        <NavLink
          to="/"
          className="dl-sidebar-item dl-sidebar-item--muted"
          title={collapsed ? 'Torna al sito' : undefined}
        >
          <span className="dl-sidebar-icon-wrap">
            <i className="bi bi-arrow-left-circle" />
          </span>
          {!collapsed && (
            <span className="dl-sidebar-label">Torna al sito</span>
          )}
        </NavLink>
      </div>
    </aside>
  );
};

export default DashboardSidebar;
